import * as SerializerLib from "jsonapi-serializer";

import { serializeError } from "../base.serializer";

const JSONAPISerializer = SerializerLib.Serializer;

const opts = {
  attributes: ["answers", "pageId", "finalized", "gRecaptchaResponse"]
};

export const serialize = (data) => {
  try {
    const Serializer = new JSONAPISerializer("survey", opts);
    return Serializer.serialize(data);
  } catch (err) {
    return serializeError(err);
  }
};
